var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('div',{staticClass:"info"},[_vm._v("超強AI數字人孵化平臺，全托管運營讓您無後顧之憂")]),_c('div',{staticClass:"button"},[_vm._v(" 聯系我們 ")])])
}]

export { render, staticRenderFns }